import { render, staticRenderFns } from "./SectionIntro.vue?vue&type=template&id=e48b1e60"
import script from "./SectionIntro.vue?vue&type=script&lang=js"
export * from "./SectionIntro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports